export const AGENCY_DATA_LENGTH: number = 0;
export const END_DAY: number = 31;
export const IS_ADOPTIVE: number = 1;
export const IS_AGENCY: number = 2;
export const SEIT: string = 'SEIT';
export const START_DAY: number = 1;
